/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BudgetPage_company$ref = any;
type BudgetPage_project$ref = any;
type RevenueRecognitionPage_company$ref = any;
type RevenueRecognitionPage_project$ref = any;
type expensesPage_company$ref = any;
type expensesPage_project$ref = any;
type ratesAndInternalCostPage_company$ref = any;
type ratesAndInternalCostPage_project$ref = any;
export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type projectBudgetV3_viewer$ref: FragmentReference;
declare export opaque type projectBudgetV3_viewer$fragmentType: projectBudgetV3_viewer$ref;
export type projectBudgetV3_viewer = {|
  +id: string,
  +email: ?string,
  +project: ?{|
    +id: string,
    +budgetType: ?BUDGET_TYPE,
    +useBaseline: ?boolean,
    +projectEndYear: ?number,
    +projectEndMonth: ?number,
    +projectEndDay: ?number,
    +companyProjectId: ?number,
    +$fragmentRefs: BudgetPage_project$ref & expensesPage_project$ref & ratesAndInternalCostPage_project$ref & RevenueRecognitionPage_project$ref,
  |},
  +company: ?{|
    +id: string,
    +modules: ?$ReadOnlyArray<?{|
      +moduleType: ?string
    |}>,
    +$fragmentRefs: BudgetPage_company$ref & expensesPage_company$ref & ratesAndInternalCostPage_company$ref & RevenueRecognitionPage_company$ref,
  |},
  +$refType: projectBudgetV3_viewer$ref,
|};
export type projectBudgetV3_viewer$data = projectBudgetV3_viewer;
export type projectBudgetV3_viewer$key = {
  +$data?: projectBudgetV3_viewer$data,
  +$fragmentRefs: projectBudgetV3_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "projectBudgetV3_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "budgetType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useBaseline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectEndYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectEndMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectEndDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyProjectId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BudgetPage_project"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "expensesPage_project"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ratesAndInternalCostPage_project"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RevenueRecognitionPage_project"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Module",
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "moduleType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BudgetPage_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "expensesPage_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ratesAndInternalCostPage_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RevenueRecognitionPage_company"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '85108671d61cdf61591b9a7a9699c380';

module.exports = node;
